
import { Component, Prop, PropSync, Vue } from "vue-property-decorator";
import { FormConfig } from "@/config";
@Component({
	name: "InputForm"
})
export default class InputForm extends Vue {
	@PropSync("formData", { type: Object }) formData_!: any;
	@PropSync("setting", { type: Array }) setting_!: any;
	@PropSync("gutter", { type: Number, default: 40 }) _gutter?: Number;
	@PropSync("rules", { type: Object, required: false }) rules_?: any;
	currentFileList: any = [];
	@PropSync("fileList", { type: Array, default: () => [] }) fileList_!: any;
	@PropSync("labelWidth", {
		type: String,
		default: "80px"
	})
	labelWidth_!: any;
	@PropSync("labelPosition", {
		type: String,
		default: "left"
	})
	labelPosition_!: any;
	@PropSync("formName", {
		type: String,
		default: "left"
	})
	formName_!: any;
	unit_nature: any = [];
	unit_type: any = [];
	industry: any = [];
	tech_field: any = [];
	price_type: any = [];
	price: any = "元";
	isSend: any = false;
	num: number = 60;
	timer: any;
	sendCodeText: string = "发送验证码";
	submit() {
		this.$emit("submit");
	}
	startLoading() {
		this.countDown();
	}
	countDown() {
		if (this.num > 0) {
			this.num -= 1;
			this.sendCodeText = `${this.num}秒后`;
			this.timer = setTimeout(this.countDown, 1000);
			this.isSend = true;
		} else {
			this.resetCountDown();
		}
	}
	resetField() {
		const refName = this.formName_;
		(this.$refs[refName] as any).resetFields();
		(this.$refs[refName] as any).clearValidate();
	}
	resetCountDown() {
		clearTimeout(this.timer);
		this.timer = null;
		this.num = 60;
		this.sendCodeText = "发送验证码";
		this.isSend = false;
	}
	handleClickBtn(type: string) {
		switch (type) {
			case "primary":
				this.validForm();
				break;
			case "cancel":
				this.$emit("cancel");
				break;
			default:
				break;
		}
	}
	handleRemove() {}
	beforeRemove() {}
	httpRequest(file: any) {
		const params = new FormData();

		params.append("file", file.file);
		this.$store.dispatch("project/uploadFile", params).then((data: any) => {
			this.formData_.upload = data;
		});
	}
	handleClose(done: any) {
		this.$confirm("确认跳过实名认证?")
			.then(_ => {
				done();
				this.$router.push({ name: "CenterLogin" });
				this.$message.success("您尚未实名认证,请在登录后尽快进行认证");
			})
			.catch(_ => {
				this.$message.warning("取消跳过实名认证");
			});
	}
	checkName = (rule: any, value: any, callback: any) => {
		// 带括号
		const reg = /^[\u4E00-\u9FA5A-Za-z]{2,20}$/;

		if (!reg.test(value)) {
			callback(new Error("请输入正确的姓名"));
		} else {
			callback();
		}
	};
	checkUnitName = (rule: any, value: any, callback: any) => {
		// 带括号
		const reg = /^[\u4E00-\u9FA5A-Za-z]{2,20}$/;

		if (!reg.test(value)) {
			callback(new Error("请输入中英文的企业名称"));
		} else {
			callback();
		}
	};
	checkAct = (rule: any, value: any, callback: any) => {
		const reg = /^[a-zA-Z][a-zA-Z0-9_]{5,9}$/;

		if (!reg.test(value)) {
			callback(new Error("请输入首字母英文的账号(6-10位)"));
		} else {
			callback();
		}
	};
	checkPhone = (rule: any, value: any, callback: any) => {
		const reg = /^1[345789]\d{9}$/;

		if (!reg.test(value)) {
			callback(new Error("请输入11位手机号"));
		} else {
			callback();
		}
	};
	checkIdCard = (rule: any, value: any, callback: any) => {
		const reg = /^(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
		if (!reg.test(value)) {
			callback(new Error("请输入正确的身份证号"));
		} else {
			callback();
		}
	};
	checkSocialIdCard = (rule: any, value: any, callback: any) => {
		const reg = /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}/;
		if (!reg.test(value)) {
			callback(new Error("请输入正确的社会统一信用代码"));
		} else {
			callback();
		}
	};
	checkEmail = (rule: any, value: any, callback: any) => {
		const reg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
		if (!reg.test(value)) {
			callback(new Error("请输入正确的邮箱"));
		} else {
			callback();
		}
	};
	checkPsd = (rule: any, value: any, callback: any) => {
		const reg = /^[A-Za-z0-9]{5,9}$/;

		if (!reg.test(value)) {
			callback(new Error("请输入6-10位数的密码"));
		} else {
			callback();
		}
	};
	defaultRules = {
		email: [
			{
				required: false,
				message: "请输入邮箱",
				trigger: "change"
			},
			{ validator: this.checkEmail }
		],
		rEmail: [
			{
				required: true,
				message: "请输入邮箱",
				trigger: "change"
			},
			{ validator: this.checkEmail }
		],
		rePassword: [
			{
				required: true,
				message: "请输入重复密码",
				trigger: "change"
			}
		],
		password: [
			{
				required: true,
				message: "请输入密码",
				trigger: "change"
			}
		],
		name: [
			{
				required: true,
				message: "请输入名字",
				trigger: "change"
			},
			{ validator: this.checkName }
		],
		upload: [
			{
				required: true,
				message: "请上传文件",
				trigger: "change"
			}
		],
		phone: [
			{
				required: true,
				message: "请输入手机号",
				trigger: "change"
			},
			{ validator: this.checkPhone }
		],
		idCard: [
			{
				required: true,
				message: "请输入身份证",
				trigger: "change"
			},
			{ validator: this.checkIdCard }
		],
		legalIdCard: [
			{
				required: true,
				message: "请输入身份证",
				trigger: "change"
			},
			{ validator: this.checkIdCard }
		],
		legalName: [
			{
				required: true,
				message: "请输入法人名称",
				trigger: "change"
			},
			{ validator: this.checkName }
		],
		reCapital: [
			{
				required: true,
				message: "请输入注册资本",
				trigger: "change"
			}
		],
		address: [
			{
				required: true,
				message: "请输入具体地址",
				trigger: "change"
			}
		],
		coAddress: [
			{
				required: true,
				message: "请选择地区",
				trigger: "change"
			}
		],
		type: [
			{
				required: true,
				message: "请选择账号类型",
				trigger: "change"
			}
		],
		unitType: [
			{
				required: true,
				message: "请选择企业类型",
				trigger: "change"
			}
		],
		organizationTypetime: [
			{
				required: true,
				message: "请选择企业类型",
				trigger: "change"
			}
		],
		industry: [
			{
				required: true,
				message: "请选择所属行业",
				trigger: "change"
			}
		],
		techField: [
			{
				required: true,
				message: "请选择技术领域",
				trigger: "change"
			}
		],
		socialIdCard: [
			{
				required: true,
				message: "请输入统一社会信用代码",
				trigger: "change"
			},
			{ validator: this.checkSocialIdCard }
		],
		tel: [
			{
				required: true,
				message: "请输入手机号",
				trigger: "change"
			},
			{ validator: this.checkPhone }
		],
		act: [
			{
				required: false,
				message: "请输入账号",
				trigger: "change"
			},
			{ validator: this.checkAct }
		],
		cName: [
			{
				required: true,
				message: "请输入企业名称",
				trigger: "change"
			},
			{ validator: this.checkUnitName }
		],
		unitName: [
			{
				required: true,
				message: "请输入企业名称",
				trigger: "change"
			},
			{ validator: this.checkUnitName }
		],
		psd: [
			{
				required: true,
				message: "请输入密码",
				trigger: "change"
			},
			{ validator: this.checkPsd }
		],
		psd2: [
			{
				required: true,
				message: "请输入重复密码",
				trigger: "change"
			}
		],
		verifyCode: [
			{
				required: true,
				message: "请输入验证码",
				trigger: "change"
			}
		]
	};

	clear() {
		(this.$refs[this.formName_] as any).clearValidate();
	}
	validFormReturn() {
		return new Promise((resolve: any, reject: any) => {
			const item: any = this.$refs[this.formName_];

			item.validate((valid: any) => {
				if (valid) {
					resolve(true);
					return true;
				}
				resolve(false);
				return false;
			});
		});
	}
	validForm() {
		const item: any = this.$refs[this.formName_];

		item.validate((valid: any) => {
			if (valid) {
				this.$emit("submit");
				return true;
			}
			// this.$message.warning("请正确填写表单")
			return false;
		});
	}
	sendCode() {
		this.$emit("sendCode");
	}
	created() {
		this.getData();
	}
	getData() {
		const { unit_nature, unit_type, industry, tech_field } = FormConfig;
		this.unit_nature = unit_nature;
		this.unit_type = unit_type;
		this.industry = industry;
		this.tech_field = tech_field;
	}
}
